var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSidebarIcon4 = function SvgSidebarIcon4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.00585938,
    width: 18,
    height: 18,
    rx: 9,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2015 9.97014V7.43754L8.0801 9.97014H9.2015ZM6.6059 9.69294L8.6597 5.44674C8.7227 5.32074 8.7983 5.20734 8.9369 5.20734H10.4615C10.6001 5.20734 10.7135 5.32074 10.7135 5.44674V9.97014H11.2679C11.3939 9.97014 11.5073 10.0835 11.5073 10.2221V10.9781C11.5073 11.1167 11.3939 11.2301 11.2679 11.2301H10.7135V12.7547C10.7135 12.8807 10.6001 12.9941 10.4615 12.9941H9.4535C9.3149 12.9941 9.2015 12.8807 9.2015 12.7547V11.2301H6.7949C6.6689 11.2301 6.5555 11.1167 6.5555 10.9781V9.84414C6.5555 9.79374 6.5807 9.73074 6.6059 9.69294Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSidebarIcon4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sidebar-icon-4.ab42f765.svg";
export { ForwardRef as ReactComponent };